export const getOptimizedImageUrl = (imageUrl: string | undefined): string | undefined => {
  const regex = /^((?:(?!\b\/image\/upload\/\b).)*)\/image\/upload\//;

  if (!imageUrl) {
    return undefined;
  }
  return imageUrl.replace(regex, '$1/image/upload/f_auto,q_auto/');
};
